<div class="menu-search-overlay" *ngIf="isOpen" (click)="close()">
	<div class="menu-search-dialog" (click)="$event.stopPropagation()" role="dialog" aria-modal="true" aria-labelledby="menu-search-title">
		<div class="menu-search-header">
			<svg class="search-icon" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2">
				<circle cx="11" cy="11" r="8"/>
				<path d="m21 21-4.35-4.35"/>
			</svg>
			<input
				type="text"
				class="menu-search-input"
				[value]="searchQuery"
				(input)="onSearchInput($event)"
				placeholder="Search menu..."
				autocomplete="off"
				aria-label="Search menu"
				id="menu-search-title"
			/>
			<kbd class="esc-kbd">ESC</kbd>
			<button type="button" class="menu-search-close" (click)="close()" aria-label="Close search">
				<i class="material-icons" aria-hidden="true">close</i>
			</button>
		</div>

		<div class="menu-search-results">
			<ng-container *ngIf="!searchQuery.trim()">
				<div class="results-section" *ngIf="recentItems.length > 0">
					<div class="results-section-header">
						<svg class="section-icon" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2">
							<circle cx="12" cy="12" r="10"/>
							<polyline points="12 6 12 12 16 14"/>
						</svg>
						<span>Recently Used</span>
					</div>
					<button
						type="button"
						class="result-item"
						[class.result-item--selected]="selectedIndex === i"
						*ngFor="let item of recentItems; let i = index; trackBy: trackById"
						(click)="navigateToItem(item)"
						(mouseenter)="selectedIndex = i"
					>
						<ng-container *ngTemplateOutlet="itemIcon; context: { $implicit: item }"></ng-container>
						<div class="result-item-content">
							<div class="result-item-main">
								<span class="result-item-label">{{ item.title }}</span>
							</div>
							<div class="result-item-section">{{ item.section }}</div>
						</div>
						<button type="button" class="pin-button" [class.pin-button--pinned]="isPinned(item)" (click)="togglePin(item, $event); $event.stopPropagation()" [attr.aria-label]="isPinned(item) ? 'Unpin' : 'Pin'">
							<svg class="pin-icon" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2">
								<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
							</svg>
						</button>
					</button>
				</div>
				<div class="results-section" *ngIf="pinnedItems.length > 0">
					<div class="results-section-header">
						<svg class="section-icon" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2">
							<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
						</svg>
						<span>Frequently Used</span>
					</div>
					<button
						type="button"
						class="result-item"
						[class.result-item--selected]="selectedIndex === recentItems.length + i"
						*ngFor="let item of pinnedItems; let i = index; trackBy: trackById"
						(click)="navigateToItem(item)"
						(mouseenter)="selectedIndex = recentItems.length + i"
					>
						<ng-container *ngTemplateOutlet="itemIcon; context: { $implicit: item }"></ng-container>
						<div class="result-item-content">
							<div class="result-item-main">
								<span class="result-item-label">{{ item.title }}</span>
							</div>
							<div class="result-item-section">{{ item.section }}</div>
						</div>
						<button type="button" class="pin-button pin-button--pinned" (click)="togglePin(item, $event); $event.stopPropagation()" aria-label="Unpin">
							<svg class="pin-icon" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2">
								<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
							</svg>
						</button>
					</button>
				</div>
			</ng-container>
			<ng-container *ngIf="searchQuery.trim()">
				<div class="results-section" *ngIf="filteredItems.length > 0">
					<div class="results-section-header">
						<span>{{ filteredItems.length }} result{{ filteredItems.length === 1 ? '' : 's' }}</span>
					</div>
					<button
						type="button"
						class="result-item"
						[class.result-item--selected]="selectedIndex === i"
						*ngFor="let item of filteredItems; let i = index; trackBy: trackById"
						(click)="navigateToItem(item)"
						(mouseenter)="selectedIndex = i"
					>
						<ng-container *ngTemplateOutlet="itemIcon; context: { $implicit: item }"></ng-container>
						<div class="result-item-content">
							<div class="result-item-main">
								<span class="result-item-label">{{ item.title }}</span>
							</div>
							<div class="result-item-section">{{ item.section }}</div>
						</div>
						<button type="button" class="pin-button" [class.pin-button--pinned]="isPinned(item)" (click)="togglePin(item, $event); $event.stopPropagation()" [attr.aria-label]="isPinned(item) ? 'Unpin' : 'Pin'">
							<svg class="pin-icon" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2">
								<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
							</svg>
						</button>
					</button>
				</div>
				<div class="empty-state" *ngIf="filteredItems.length === 0">
					<svg class="empty-icon" viewBox="0 0 24 24" width="48" height="48" fill="none" stroke="currentColor" stroke-width="2">
						<circle cx="11" cy="11" r="8"/>
						<path d="m21 21-4.35-4.35"/>
					</svg>
					<p class="empty-title">No results found</p>
					<p class="empty-text">Try another term</p>
				</div>
			</ng-container>
		</div>

		<div class="menu-search-footer">
			<div class="footer-hints">
				<span class="hint"><kbd class="kbd-arrows">↑</kbd><kbd class="kbd-arrows">↓</kbd> Navigate</span>
				<span class="hint"><kbd class="kbd-enter">Enter</kbd> Select</span>
			</div>
			<div class="footer-action">
				<svg class="footer-icon" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2">
					<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
				</svg>
				<span>Star to favorite</span>
			</div>
		</div>
	</div>
</div>

<ng-template #itemIcon let-item>
	<i *ngIf="item.isMaterialIcon" class="material-icons result-item-icon">{{ item.icon }}</i>
	<span *ngIf="!item.isMaterialIcon" class="result-item-abbr">{{ item.icon }}</span>
</ng-template>
